import {post} from "@/utils/request";
import apiCommonCategory from "@/api/common-category";

export default class apiBkBookCart extends apiCommonCategory{
  static module = 'bk_book_cart'

  static async listDel(ids){
    return post('/home/bk_book_cart/listDel', {ids})
  }

  static async setNum(id, num){
    return post('/home/bk_book_cart/setNum', {id, num})
  }

  static async batchSetNum(ids, num){
    return post('/home/bk_book_cart/batchSetNum', {ids, num})
  }

  static async add(bookId){
    return post('/home/bk_book_cart/add', {bookId})
  }

  static async remove(bookId){
    return post('/home/bk_book_cart/remove', {bookId})
  }

  static async getBookCount(){
    return post('/home/bk_book_cart/getBookCount')
  }

  static async checkDuplicateBooks(){
    return post('/home/bk_book_cart/checkDuplicateBooks')
  }
}
